import React, { FC, ReactNode } from 'react'

import { FormattedMessage } from 'react-intl'

import { VoidHandler } from 'common/types'
import { ToolTipSize } from 'common-constants/sizes'
import {
  tooltipTop,
  Tooltip,
} from 'components/block/PhotoLine/PhotoLineTooltip.styled'
import { Message } from 'components/page/ForeignProfile/Gifts/GiftDescription/GiftDescription.styled'
import { SmallOrdinaryButton } from 'components/presentational/button'
import { CenterTooltip } from 'components/presentational/Tooltip'
import { zIndex } from 'components/presentational/zIndex'

/**
 * TODO: нужно объединить с src/common/components/block/PhotoLineIndex/PhotoLineTooltip.tsx и вынести в отдельный tooltip для такой фигни
 * @param message
 * @param userDetails
 * @param userPhotoGift
 * @param showRemoveSignature
 * @param hiddenAuthor
 * @param onRemoveSignature
 * @param onHideAuthor
 * @returns {JSX.Element}
 * @constructor
 */
export const GiftTooltip: FC<{
  message: ReactNode
  userDetails: ReactNode
  userPhotoGift: ReactNode
  showRemoveSignature?: boolean
  hiddenAuthor?: boolean
  onRemoveSignature?: VoidHandler
  onHideAuthor?: VoidHandler
}> = ({
  message,
  userDetails,
  userPhotoGift,
  showRemoveSignature = false,
  hiddenAuthor = false,
  onRemoveSignature,
  onHideAuthor,
}): JSX.Element => (
  <CenterTooltip
    style={{ top: tooltipTop, zIndex: zIndex.overAdvertising + 1 }}
  >
    <Tooltip style={{ width: `${ToolTipSize.gift}px` }} data-tooltip="tooltip">
      {userPhotoGift}
      <div>
        {userDetails}
        {message && <Message>{message}</Message>}
        {showRemoveSignature && (
          <SmallOrdinaryButton onClick={onRemoveSignature}>
            <FormattedMessage id="profile.gift.remove_signature" />
          </SmallOrdinaryButton>
        )}
        {hiddenAuthor && (
          <SmallOrdinaryButton onClick={onHideAuthor}>
            <FormattedMessage id="profile.gift.hide_author" />
          </SmallOrdinaryButton>
        )}
      </div>
    </Tooltip>
  </CenterTooltip>
)
